import { getTypographyStyles, SEM_TYPOGRAPHY_FORMS_APPENDIX, SYS_SPACE_FIXED_100 } from '@oneaudi/unified-web-common';
import React from 'react';
import styled from 'styled-components';
import { isString } from '../utils.js';
import { Badge } from '../../badge/index.js';
export const StyledCaption = styled.span `
  display: flex;
  flex-direction: column;
  gap: ${SYS_SPACE_FIXED_100};
`;
export const StyledCaptionHint = styled.span `
  color: ${(props) => props.theme.sem.color.forms.foreground.text.caption};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_APPENDIX)};
`;
export const Caption = ({ label, captionHint }) => (React.createElement(StyledCaption, null,
    label,
    captionHint && (React.createElement(React.Fragment, null, isString(captionHint) ? (React.createElement(StyledCaptionHint, null, captionHint)) : (React.createElement(Badge, { label: captionHint.label, semanticShape: captionHint.semanticShape }))))));
//# sourceMappingURL=caption.js.map